import { isValidPhoneNumber, isValidContactName } from "../../../../Shared/Assets/utils";

(function ($, w) {
  $(function () {
    $.validator.addMethod(
      "auphonenumber",
      function (value, element, params) {
        return isValidPhoneNumber(value);
      },
      "Valid phone number required"
    );

    $.validator.addMethod(
      "contactname",
      function (value, element, params) {
        return isValidContactName(value);
      },
      "Valid name required"
    );

  });
})(jQuery, window);
